import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, } from 'react';
const TableBody = ({ children, }) => (_jsx("tbody", { children: children }));
const MemoizedTableBody = memo(TableBody);
export { MemoizedTableBody as TableBody };
// MC-1068 Temporary hack for Storybook.
export default TableBody;
